<template>
    <div style="height: 100%">
        <app-base-main parentTable>
            <template #operate-group>
                <span>站外邮箱</span>
                <gj-button type="primary" @click="addMailbox">新增邮箱</gj-button>
            </template>
            <template #tool-group>
                <gj-tool-group log @viewLog="viewLog">
                </gj-tool-group>
            </template>

            <template #table>
                <gj-table ref="gjTable" adaptParent :data="tableData" :columns="columns" :index="false" :loading="loading" :pagination="pagination" @page-change="$gjNoticeQuery">
                    <template v-slot:type="{ row }">
                        <div>
                            {{ row.type == "1" ? "站内" : row.type == "2" ? "站外" : row.type }}
                        </div>
                    </template>
                     <template v-slot:status="{ row }">
                        <div>
                            {{ row.status == "AuthCodeError" ? "密码错误" : row.status == "Normal" ? "正常" : row.status == "Unbind" ? "已解绑" : "-"}}
                        </div>
                    </template>
                    <template v-slot:op="{ row }">
                        <gj-button type="text" @click="editMailbox(row)">编辑</gj-button>
                        <gj-button type="text" @click="authorityManager(row)">权限管理</gj-button>
                        <gj-button type="text" @click="unbound(row)">解绑</gj-button>
                    </template>
                </gj-table>
            </template>
        </app-base-main>
        <!-- 权限管理  -->
        <gj-modal
            :visible.sync="addUserFlag"
            notFooterPadding
            :confirm-loading="editLoading"
            @cancel="editCancel"
            @confirm="editConfirm"
            size="800_auto"
        >
        <template #header>
            <span>权限管理</span>
        </template>
        <template #content>
            <div>
            <el-transfer
                style="text-align: left;justify-content: center;"
                v-model="checkUserList"
                filterable
                :titles="['未选用户', '已选用户']"
                :format="{
                    noChecked: '${total}',
                    hasChecked: '${checked}/${total}'
                }"
                :data="userList">
            </el-transfer>
            </div>
        </template>
        </gj-modal>
    </div>
</template>

<script>
  import {isMeaningfulMixin, queryMixin, selectionMixin, responseMixin} from "../../../../minxins";
import OffSiteMailboxLog from './modal/off-site-mailbox-log';
import AddMailboxLog from './modal/add-mailbox';
import EditMailboxLog from './modal/edit-mailbox';
import { getOutEmailPageList, unbindEmail, updateOutEmail} from '../../../../api/crm'
import { findAll } from '../../../../api/setting'
import { el } from 'date-fns/locale';

export default {
    name: "off-site-mailbox",
    mixins: [queryMixin, selectionMixin, isMeaningfulMixin, responseMixin],
    data() {
        return {
            loading: false,
            editLoading: false,
            tableData: [],
            columns: [
                { id: 'account', header: '邮箱', field: 'account', },
                { id: 'status', header: '状态', field: 'slot:status', },
                { id: 'type', header: '邮件类型', field: 'slot:type', },
                { id: 'op', header: '操作', field: 'slot:op', fixed: 'right', width: '150px' },
            ],
            userList: [],
            checkUserList: [],
            addUserFlag: false,
            editItem: {},
        }
    },
    methods: {
        $gjQuery() {
            //获取站外邮件
            this.loading = true;
            const params = {
                map: {},
                model: {},
                ...this.queryPagination,
                ...this.querySort,
            };
            getOutEmailPageList(params)
            .then((data) => {
                this.tableData = data.records;
                this.pagination = this.getPagination(data);
            }).complete(() => this.loading = false)
            

        },
        viewLog() {
            this.$gjCreate(OffSiteMailboxLog)
        },
        addMailbox() {
             const modal = this.$gjCreate(AddMailboxLog, {
                on: {
                    after: () => {
                        this.$gjResetPage();
                        modal.$gjDestroy();
                    }
                }
            })
        },
        editMailbox(row) {
            const modal = this.$gjCreate(EditMailboxLog, {
                props: {
                    item:{
                         ...row
                    }
                },
                on: {
                    after: () => {
                        this.$gjResetPage();
                        modal.$gjDestroy();
                    }
                }
            })
        },
        unbound(row) {
            const modal = this.$gjCreate('gj-info-modal', {
                props: {
                    title: '解绑确认',
                    content: `确定要解绑${row.account}吗？`
                },
                on: {
                cancel: () => modal.$gjDestroy(),
                confirm: () => {
                    modal.confirmLoading = true;
                    unbindEmail(row.emailId)
                        .then((res) => {
                        this.$gjResponseHandle(res, () => {
                            
                            this.$gjResetPage();
                            modal.$gjDestroy();
                        })
                        }).complete(() => modal.confirmLoading = false)
                }
                }
            });
        },
        transitionObj(data){
          const list = [];
          if(data === null || data.length == 0){
            return list;
          }
          for (var i=0;i<data.length;i++){
            list.push({
              key: data[i].id,
              label: data[i].name,
            })
          }
          return list;
        },
        editConfirm() {
           this.editLoading = true
          
           var userCheckSet = new Set(this.checkUserList);
            const params = {
            id: this.editItem.emailId,
            account: this.editItem.account,
            authCode: this.editItem.authCode,
            imapPort: this.editItem.imapPort,
            imapServer: this.editItem.imapServer,
            imapSsl: this.editItem.imapSsl,
            status: this.editItem.status,
            userIds: userCheckSet
            }
           updateOutEmail(params).then((res) => {
                this.$gjResponseHandle(res, () => {
                    this.$gjMessage.success('操作成功');
                     this.$gjResetPage();
                 }, () => {
                      this.$gjMessage.success('操作失败');
                 })
               this.addUserFlag = false;
           }).complete(() => this.editLoading = false)
           
        },
        editCancel() {
            this.editItem = {};
            this.addUserFlag = false;
        },
        authorityManager(row) {
            this.editItem = row ?? {};
            if (this.editItem.userIds !== undefined) {
                var checks = row.userIds ?? {};
                this.checkUserList = Array.from(checks);
            }else {
                this.editItem.userIds = {}
                this.checkUserList = [];
            }
            this.addUserFlag = true;
        }
    },
     created(){
        //查询出所有用户
        findAll().then(response => {
           this.userList = this.transitionObj(response.data)
        })
      },
}
</script>

<style scoped>
</style>
